import React from 'react'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { Link, NavLink } from 'react-router-dom'

export default function TopNav() {
    return (
        <div className='sticky-top'>
            <Navbar fixed="top" className="navbar" collapseOnSelect expand="lg" >
                <Container fluid>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Brand as={Link} to="/"> <img className="logo" src="/images/logo1.png" /> </Navbar.Brand>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav defaultActiveKey="/" className="me-auto nav ">
                            <NavLink className="nav-link" as={Link} to='/' >Home</NavLink>
                            <NavLink className="nav-link" as={Link} to='/about'>About Us</NavLink>
                            <NavLink className="nav-link" as={Link} to='/services'>Our Services</NavLink>
                            <NavLink className="nav-link" as={Link} to='/client'>Our Clients</NavLink>
                            <NavLink className="nav-link" as={Link} to='/contact'>Contact Us</NavLink>
                        </Nav>
                        <Nav>
                            <a className="nav-link"  href='/images/pdf/quote.pdf' target="_blank"> <div className='nav_link_quote'> Get Quote </div></a>
                            <a className="nav-link"  href='tel:+917799430362'> <div className='phone_link'> +917799430362 </div></a>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
